import React, { createContext, useState } from 'react';

export const VisibleContext = createContext();
export const SetVisibleContext = createContext();

export const Provider = ({ children }) => {
  const [visible, setVisible] = useState(false);

  return (
    <VisibleContext.Provider value={visible}>
      <SetVisibleContext.Provider value={setVisible}>
        {children}
      </SetVisibleContext.Provider>
    </VisibleContext.Provider>
  );
};
